import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { AttributeDefinitionCondition } from '../attributes/attributeDefinitionCondition';
import { AttributeDefinitionSubFieldItem } from '../attributes/attributeDefinitionSubFieldItem';

export class FormAttributeDefinition extends AttributeDefinition {
  public showCurrentValue: boolean;
  public isSubField: boolean;
  constructor(
    id: string,
    entityType: string,
    uiType: string,
    name: string,
    description: string,
    adminDocumentation: string,
    filterable: boolean,
    featured: boolean,
    showOnCreate: boolean,
    isSubField: boolean,
    required: boolean,
    min: string,
    max: string,
    allowsUserAddedValues: boolean,
    valueList: AttributeDefinitionValueListItem[],
    subFieldList: AttributeDefinitionSubFieldItem[],
    showCurrentValue: boolean,
    isReadOnly: boolean,
    isHidden: boolean,
    conditions: AttributeDefinitionCondition[],
    formPageId: string
  ) {
    super(
      id,
      entityType,
      uiType,
      name,
      description,
      adminDocumentation,
      filterable,
      featured,
      required,
      isReadOnly,
      isHidden,
      false,
      showOnCreate,
      isSubField,
      min,
      max,
      allowsUserAddedValues,
      valueList,
      subFieldList,
      null,
      null,
      null,
      null,
      null
    );
    this.showCurrentValue = showCurrentValue;
    this.conditions = conditions;
    this.formPageId = formPageId;
  }

  static parse(obj: any): FormAttributeDefinition {
    let attributeDefinition = AttributeDefinition.parse(obj);
    return new FormAttributeDefinition(
      attributeDefinition.id,
      attributeDefinition.entityType,
      attributeDefinition.uiType,
      attributeDefinition.name,
      attributeDefinition.description,
      attributeDefinition.adminDocumentation,
      attributeDefinition.filterable,
      attributeDefinition.featured,
      attributeDefinition.showOnCreate,
      attributeDefinition.isSubField,
      attributeDefinition.required,
      attributeDefinition.min,
      attributeDefinition.max,
      attributeDefinition.allowsUserAddedValues,
      attributeDefinition.valueList,
      attributeDefinition.subFieldList,
      obj.showCurrentValue,
      obj.isReadOnly,
      obj.isHidden,
      obj.conditions,
      obj.formPageId
    );
  }
}
